import React from "react"
import useAsyncResultIdle from "../../../hooks/useAsyncResultIdle"
import {useAccessToken} from "../../../services/auth"
import {AsyncResultModal} from "../../../components/AsyncResultModal/AsyncResultModal"
import {archiveWhiteLabelAppUser, WhiteLabelAppUser} from "../../../resources/whiteLabel"
import Admonition from "../../../components/Admonitions/Admonition"

type CloseFunc = () => void
type RefreshFunc = () => void

interface ModalProps {
	close: CloseFunc
	refresh: RefreshFunc
	user: WhiteLabelAppUser
}

export function ArchiveManagedSolutionsUserModal({close, refresh, user}: ModalProps) {
	const accessToken = useAccessToken()
	const [statusChangeState, archiveUser] = useAsyncResultIdle(archiveWhiteLabelAppUser)
	return (
		<AsyncResultModal
			title="Archive Managed Solutions User"
			onSubmit={() => archiveUser(accessToken, user.id)}
			close={close}
			state={statusChangeState}
			buttonClassname="is-warning"
			buttonText="Archive"
			successText="Archived"
			errorToText={(err) => err.errors[0].detail || err.errors[0].title}
			onSuccess={refresh}
		>
			<Admonition
				title={"Confirmation"}
				type={"is-warning"}
				message={
					<>
						<div className="archive-managed-solutions-user-confirmation">
							<span>Are you sure you want to archive the Managed Solutions user</span>
							<span>
								<strong>{user.attributes.externalUserId}</strong> ?
							</span>
						</div>
						<div className="archive-managed-solutions-user-warning">
							This action will archive the user&apos;s application and cannot be undone. The user will have to start
							over with a new application on their next login.
						</div>
						<div className="archive-managed-solutions-user-warning">
							If this user is linked to a customer that is not archived yet, this action will fail and the user will
							remain active.
						</div>
					</>
				}
			/>
		</AsyncResultModal>
	)
}
